import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaRocket,
  FaEye,
  FaUsers,
  FaCheckCircle,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const DocumentaryProductionInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Documentary Production in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Tell Your Story</Subheading>}
        heading={
          <Heading>
            Documentary <span tw="text-primary-500">Production</span> in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide professional documentary production
            services in **Dubai**, crafting authentic, impactful films that
            capture real stories and resonate with audiences. From human rights
            narratives to corporate documentaries, our award-winning team brings
            your vision to life with cinematic quality.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1551966775-a4ddc8df052b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Professional camera setup
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Cinematic storytelling
          "https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Director on set
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Documentary"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Documentary Production in Dubai"
        description="We create documentaries that inform, inspire, and engage."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Authentic Storytelling",
            description: "Compelling narratives that reflect real experiences.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Award-Winning Team",
            description: "Recognized for excellence in film festivals.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Efficient Production",
            description: "Timely delivery with high-quality results.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Emotional Impact",
            description: "Films designed to captivate audiences.",
          },
          {
            icon: <FaUsers color="#ff5464" size={40} />,
            title: "Diverse Formats",
            description: "From short films to feature-length documentaries.",
          },
          {
            icon: <FaCheckCircle color="#ff5464" size={40} />,
            title: "End-to-End Service",
            description: "From concept to post-production.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Documentary Production Process"
        description={
          <Description>
            We craft powerful documentaries with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Discovery: Understand your story and objectives.</li>
              <li>
                Research: Conduct in-depth analysis and location scouting.
              </li>
              <li>Scripting: Develop compelling narratives and storyboards.</li>
              <li>
                Filming: Use 4K equipment and skilled crews for stunning
                visuals.
              </li>
              <li>
                Editing: Enhance with motion graphics, sound design, and
                subtitles.
              </li>
              <li>
                Delivery: Provide polished films with unlimited revisions.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1540655037529-dec987208707?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Filmmaking equipment
          "https://images.unsplash.com/photo-1633080413606-2c21b92bd7b8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Video editing process
          "https://images.unsplash.com/photo-1470790376778-a9e6b6a93fa3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Creative production setup
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Documentary Wins in Dubai"
        description="Our films have inspired and informed audiences."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Festival Recognition",
            description: "Won awards at international film festivals.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Audience Engagement",
            description: "Drove impact for a social justice campaign.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from documentary clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Share Your Story?</Subheading>}
        heading="Documentary Production in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for professional documentary production
            services in Dubai. Get authentic, cinematic films that captivate and
            inspire—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Authentic documentary moment
          "https://images.unsplash.com/photo-1560474451-dc18a9c78a5c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Professional camera work
          "https://images.unsplash.com/photo-1517799094725-e3453440724e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80", // Documentary filming scene
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
